import { render } from "./SSRDCriteria2View.vue?vue&type=template&id=0887c17a"
import script from "./SSRDCriteria2View.vue?vue&type=script&lang=js"
export * from "./SSRDCriteria2View.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__